import React from 'react';
import { Modal, ModalActions } from '../../ui/Modal/Modal';
import { Button } from '../../ui/Button/Button';

interface MaintenanceModalProps {
    open: boolean;
    onClose: () => void;
}

export const MaintenanceModal = ({ open, onClose }: MaintenanceModalProps) => (
    <Modal
        open={open}
        title="Уважаемые пользователи!"
        width={560}
        onClose={onClose}
        footer={
            <ModalActions>
                <Button onClick={onClose} >
                    Понятно
                </Button>
            </ModalActions>
        }
    >
        <p style={{ textIndent: '30px', textAlign: 'justify', margin: 0 }}>
            Информируем Вас о проведении плановых технических работ по обновлению платформы.
            В связи с этим доступ к системе будет временно ограничен до 12 октября 2026 года.
        </p>
        <p style={{ textIndent: '30px', textAlign: 'justify', margin: 0 }}>
            Приносим извинения за возможные неудобства и благодарим за понимание.
            Обновление сделает работу платформы ещё удобнее, стабильнее и эффективнее.
        </p>
    </Modal >
);